// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_96-0";
export var optionCard = "_96-1";